import React from 'react';
import ornament from '../../assets/img/ornament-sell.svg';
import icon1 from '../../assets/img/icons/wcu-1.svg';
import icon2 from '../../assets/img/icons/wcu-2.svg';
import icon4 from '../../assets/img/icons/wcu-4.svg';
import icon5 from '../../assets/img/icons/wcu-5.svg';
import icon6 from '../../assets/img/icons/wcu-6.svg';
import icon7 from '../../assets/img/icons/wcu-7.svg';

const items = [
  {
    image: icon6,
    title: (
      <>
        <span>Franchise</span> dealer stock only
      </>
    ),
    caption: 'We only list used cars and vans from trusted franchise dealer network.',
    imageAlt: 'Location pins',
  },
  {
    image: icon1,
    title: (
      <>
        <span>Quality & Quantity</span> Consistently
      </>
    ),
    caption:
      'When it comes to stock, we pride ourselves in having a consistent level of volume and quality available on our site.',
    imageAlt: 'Quality badge',
  },
  {
    image: icon7,
    title: (
      <>
        <span>Simple & clean</span> platform
      </>
    ),
    caption:
      'Simple to use, easy to navigate, and built to help you focus on selling and buying stock.',
    imageAlt: 'Human icon',
  },
  {
    image: icon4,
    title: (
      <>
        <span>No nonsense</span> process
      </>
    ),
    caption: 'No faff, no fuss – just clear listings and a simple way to buy and sell.',
    imageAlt: 'Location pins',
  },
  {
    image: icon5,
    title: (
      <>
        <span>Built for</span> motor dealers
      </>
    ),
    caption: 'Created for dealers by people who understand the trade.',
    imageAlt: 'Car icon',
  },
  {
    image: icon2,
    title: (
      <>
        <span>Fair pricing with</span> no hidden fees
      </>
    ),
    caption:
      'Straightforward, honest pricing – no hidden cost, hefty bills or nasty surprises along the way.',
    imageAlt: 'Price label icon',
  },
];

function WhyChooseUs({ recentlyLaunchedAuctionsExist = false }) {
  return (
    <section
      className={`why-choose-us ${recentlyLaunchedAuctionsExist ? 'why-choose-us--small-margin' : ''}`}
    >
      <img src={ornament} alt="Arrows" className="why-choose-use__ornament" />
      <h2 className="why-choose-us__title">
        Why choose <span>The Stock Vault?</span>
      </h2>
      <h3 className="why-choose-us__subtitle">
        BUILT FOR{' '}
        <span>
          <span>MOTOR</span> DEALERS
        </span>
      </h3>
      <p className="why-choose-us__caption">
        <span>
          The Stock Vault is a B2B UK-based digital marketplace, facilitating the buying and
          selling of used cars
        </span>
        <span>
          and vans from franchised dealers. The platform is specifically designed for
          registered motor dealers.
        </span>
      </p>
      <div className="why-choose-us__features">
        {items.map((item) => (
          <div className="why-choose-us__feature">
            <div className="why-choose-us__feature-box">
              <img
                className="why-choose-us__feature-box-icon"
                src={item.image}
                alt={item.imageAlt}
              />
            </div>
            <h4 className="why-choose-us__feature-title">{item.title}</h4>
            <span className="why-choose-us__feature-caption">{item.caption}</span>
          </div>
        ))}
      </div>
    </section>
  );
}

export default WhyChooseUs;
